export const sliderData = [
  {
    id: 1,
    title: "Seed conservation and regeneration",
    description:
      "We promote eco-friendly farming practices that restore the land and strengthen communities — the true roots of sustainable growth.",
    button: { text: "Learn More", link: "/our-programs/seed-conservation-and-regeneration" },
    image: "/images/sorghum.jpeg",
  },
  {
    id: 2,
    title: "Establishing Organic Markets",
    description:
      "Empowering farmers through reliable organic markets that reward sustainable growing methods, reduce exploitation, and expand consumer access to trusted, chemical-free foods.",
    button: { text: "Learn more", link: "/our-programs/establishment-of-organic-markets" },
    image: "/images/marketing-naks.jpeg",
  },
  {
    id: 3,
    title: "Biofertilizers and Biopesticides program",
    description:
      "Our Biofertilizers and Biopesticides Program offers natural inputs that enrich soil, protect crops, and reduce reliance on chemicals—helping farmers grow healthier harvests more sustainably.",
    button: { text: "Learn more", link: "/our-programs/biofertilizers-and-biopesticides-program" },
    image: "/images/biofertilizer-naks.jpeg",
  },
  {
    id: 4,
    title: "Advocacy programs",
    description:
      "We champion resilient, community-led food systems through advocacy programs that protect indigenous seeds, promote agroecology, ensure GMO accountability, and support fair markets for smallholder farmers.",
    button: { text: "Learn more", link: "/our-programs/advocacy-programs" },
    image: "/images/advocacy-programs.jpeg",
  },
  {
    id: 5,
    title: "Youth and women empowerment",
    description:
      "We drive sustainable food systems through youth and women empowerment, combining innovation, leadership, and traditional knowledge to protect indigenous seeds and lead community change.",
    button: { text: "Learn more", link: "/our-programs/youth-and-women-empowerment" },
    image: "/images/youth-naks.jpeg",
  }
];
